import './style.scss';
import Input from "../../components/common/input";
import React, {useEffect, useState} from "react";
import SchoolForm from "./schoolForm";
//import {addSchool, clearAddSchoolErrors} from "../../actions/schools";
import {useDispatch, useSelector} from "react-redux";
import {route as MANAGE_SCHOOLS_ROUTE} from "../manageSchools/"
import {Navigate} from "react-router-dom";
import Alert from "../../components/common/alert";
import Selector from "../../components/common/selector";
import {addSchool, clearAddSchoolAlerts} from "../../actions/schools";
import {fetchDistricts, restoreCurrentDistrictFromLocalStorage} from "../../actions/districts";
import {MESSAGES} from "../../constants";
import {DEFAULT_CALENDAR_TYPE, DEFAULT_CALENDAR_YEAR} from "../../config";

export const route = 'add-school';

const BATCH_TYPE = [
  {
    label: '',
    value: ''
  },
  {
    label: 'M',
    value: 'M'
  },
  {
    label: 'A',
    value: 'A'
  }
];

const CALENDAR_TYPE = [
  {
    label: 'S',
    value: 'S'
  },
  {
    label: 'F',
    value: 'F'
  },
  {
    label: 'Q',
    value: 'Q'
  },
  {
    label: 'T',
    value: 'T'
  }
]

const AddSchool = (props) => {
  const dispatch = useDispatch();

  const [name, setName] = useState('');
  const [atpCode, setAtpCode] = useState('');
  const [city, setCity] = useState('');
  const [batchType, setBatchType] = useState('');
  const [carnegieUnitConversionFactor, setCarnegieUnitConversionFactor] = useState('');
  const [schoolYear, setSchoolYear] = useState(DEFAULT_CALENDAR_YEAR);
  const [calendarTypeCurrentYear, setCalendarTypeCurrentYear] = useState(DEFAULT_CALENDAR_TYPE);
  const [calendarTypePreviousYear, setCalendarTypePreviousYear] = useState(DEFAULT_CALENDAR_TYPE);
  const [calendarTypeTwoYearsAgo, setCalendarTypeTwoYearsAgo] = useState(DEFAULT_CALENDAR_TYPE);
  const [calendarTypeThreeYearsAgo, setCalendarTypeThreeYearsAgo] = useState(DEFAULT_CALENDAR_TYPE);

  const shouldLockForm = false;
  const errors = useSelector((state) => state.schools.addSchoolErrors);
  const addSchoolAlert = useSelector((state) => state.schools.addSchoolAlert);
  const addSchoolApiError = useSelector((state) => state.schools.addSchoolApiErrors);

  useEffect(() => {
    dispatch(restoreCurrentDistrictFromLocalStorage());
    dispatch(fetchDistricts());
  }, [dispatch]);

  const currentDistrict = useSelector((state) => state.districts.currentDistrict);

  const districts = useSelector((state) => state.districts.districts);

  const onDismissAlert = () => {
    dispatch(clearAddSchoolAlerts());
  }

  const handleKeyDown = (event) => {
    if(event.key === 'Enter'){
      submitAction(event.target.value);
    }
  }

  const submitAction = () => {
    dispatch(addSchool(
      {
        school: {
          districtId: currentDistrict.id,
            atpCode: atpCode,
          name: name,
          city: city,
          batchType: batchType
        },
        schoolDemo: {
          schoolAtpCode: atpCode,
          carnegieUnitConversionFactor: parseInt(carnegieUnitConversionFactor),
          schoolYear: schoolYear,
          calTypeCy: calendarTypeCurrentYear,
          calTypeCy1: calendarTypePreviousYear,
          calTypeCy2: calendarTypeTwoYearsAgo,
          calTypeCy3: calendarTypeThreeYearsAgo
        }
      }
    ));
  }


  return (addSchoolAlert) ? <Navigate to='/manage-schools' /> : (
    <div className='main-content'>
      <div className='add-school-header'>Create a New School</div>
      <div className='add-school-alerts'>
        {(addSchoolApiError) && <Alert onDismiss={onDismissAlert}>{MESSAGES.SCHOOLS.addSchoolApiError}</Alert>}
      </div>
      <div className='add-school-container'>
        <SchoolForm
          submitLabel='Submit'
          submitAction={submitAction}
          disabled={shouldLockForm}
        >
          <div className='form-required'>
            * - Indicates Required Fields
          </div>
          <div className='add-school-district'>
            <div className='district-label'>
              District:
            </div>
            <div className='district-name'>
              {(currentDistrict) ? currentDistrict.name : 'N/A'}
            </div>
          </div>
          <Input
            name='atpCode'
            id='atpCode'
            value={atpCode}
            label='Atp Code*'
            type='text'
            changeAction={setAtpCode}
            errors={errors?.atpCode}
          />
          <Input
            name='name'
            id='name'
            value={name}
            label='Name*'
            type='text'
            changeAction={setName}
            onKeyDown={handleKeyDown}
            errors={errors?.name}
          />
          <Input
            name='city'
            id='city'
            value={city}
            label='City*'
            type='text'
            changeAction={setCity}
            onKeyDown={handleKeyDown}
            errors={errors?.city}
          />
          <Selector
            name="batchType"
            label='Batch Type'
            value={batchType}
            changeAction={setBatchType}
            onKeyDown={handleKeyDown}
            showLabel={true}
            items={BATCH_TYPE}
          />
          <Input
            name='carnegieUnitConversionFactor'
            id='carnegieUnitConversionFactor'
            value={carnegieUnitConversionFactor}
            label='Carnegie Unit Conversion Factor'
            type='text'
            changeAction={setCarnegieUnitConversionFactor}
            onKeyDown={handleKeyDown}
            errors={errors?.carnegieUnitConversionFactor}
          />
          <Input
            name='schoolYear'
            id='schoolYear'
            value={schoolYear}
            label='School Year'
            type='text'
            changeAction={setSchoolYear}
            onKeyDown={handleKeyDown}
            errors={errors?.schoolYear}
          />
          <Selector
            name='calendarTypeCurrentYear'
            value={calendarTypeCurrentYear}
            label='Calendar Type (Current Year)'
            changeAction={setCalendarTypeCurrentYear}
            onKeyDown={handleKeyDown}
            errors={errors?.calendarTypeCurrentYear}
            items={CALENDAR_TYPE}
            showLabel={true}
          />
          <Selector
            name='calendarTypePreviousYear'
            value={calendarTypePreviousYear}
            label='Calendar Type (Previous Year)'
            changeAction={setCalendarTypePreviousYear}
            onKeyDown={handleKeyDown}
            errors={errors?.calendarTypePreviousYear}
            items={CALENDAR_TYPE}
            showLabel={true}
          />
          <Selector
            name='calendarTypeTwoYearsAgo'
            id='calendarTypeTwoYearsAgo'
            value={calendarTypeTwoYearsAgo}
            label='Calendar Type (Two Years Ago)'
            changeAction={setCalendarTypeTwoYearsAgo}
            onKeyDown={handleKeyDown}
            errors={errors?.calendarTypeTwoYearsAgo}
            items={CALENDAR_TYPE}
            showLabel={true}
          />
          <Selector
            name='calendarTypeThreeYearsAgo'
            id='calendarTypeThreeYearsAgo'
            value={calendarTypeThreeYearsAgo}
            label='Calendar Type (Three Years Ago)'
            changeAction={setCalendarTypeThreeYearsAgo}
            onKeyDown={handleKeyDown}
            errors={errors?.calendarTypeThreeYearsAgo}
            items={CALENDAR_TYPE}
            showLabel={true}
          />
        </SchoolForm>
      </div>
    </div>
  );
}

export default AddSchool;